import { render, staticRenderFns } from "./TCheckBox.vue?vue&type=template&id=858997ac&scoped=true&"
import script from "./TCheckBox.vue?vue&type=script&lang=js&"
export * from "./TCheckBox.vue?vue&type=script&lang=js&"
import style0 from "./TCheckBox.vue?vue&type=style&index=0&id=858997ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "858997ac",
  null
  
)

export default component.exports